import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getSuppliers, changeSupplierStatus } from "../../../actions/suppliers";

import { Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem } from "@blueprintjs/core";
import VirtualizedTable from "../../../components/common/virtualized-table";
import _ from "lodash";
import { List } from "immutable";

class SuppliersPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            suppliersFilter: ''
        };
    }

    componentDidMount() {
      this.props.getSuppliers({
          projection: 'supplier_code basic_info.fiscal_name basic_info.name basic_info.email basic_info.phone basic_info.mobile_phone basic_info.fiscal_id status',
          deleteVirtuals: true
      });
    };

    render() {

        const { suppliers, history } = this.props;
        const { suppliersFilter } = this.state;

        // Suppliers Table
        let tableSettings = {
            sortable: true,
            filterable: true,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 650,
            rowHeight: 40,
            strippedRows: false
        };
        let tableData = suppliers;
        let tableColumns = {
            supplier_code: {
                title: 'Código',
                columnType: 'function',
                dataField: ['_id', 'supplier_code' ],
                width: 100,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/proveedores/' + value[0] }>{ value[1] }</Link>
                }
            },
            fiscal_name: {
                title: "Nombre fiscal",
                columnType: 'function',
                dataField: ['_id', 'basic_info.fiscal_name'],
                width: 200,
                style: {},
                sortable: true,
                sortableIndex: 1,
                filterable: true,
                filterableIndex: 1,
                nodeContent: (value) => {
                    return <Link to={ '/compras/proveedores/' + value[0] }>{ value[1] }</Link>
                }
            },
            comercial_name: {
                title: "Nombre comercial",
                columnType: 'text',
                dataField: 'basic_info.name',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            email: {
                title: "Email",
                columnType: 'text',
                dataField: 'basic_info.email',
                width: 200,
                style: {},
                sortable: true,
                filterable: true
            },
            phone: {
                title: "Teléfono",
                columnType: 'text',
                dataField: 'basic_info.phone',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            mobile_phone: {
                title: "Móvil",
                columnType: 'text',
                dataField: 'basic_info.mobile_phone',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            fiscal_id: {
                title: "CIF/NIF",
                columnType: 'text',
                dataField: 'basic_info.fiscal_id',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            status: {
                title: "Estado",
                columnType: 'function',
                dataField: 'status',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    let data = value === 'active'
                        ? { badgeColor: 'primary', value: 'activo' }
                        : value === 'inactive'
                            ? { badgeColor: 'danger', value: 'inactivo' }
                            : { badgeColor: 'info', value };

                    return (
                        <div>
                            <span className={'badge badge-' + data.badgeColor}>
                                {_.capitalize(data.value)}
                            </span>
                        </div>
                    );
                }
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: ['_id', 'status'],
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (value) => {
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ver detalle" onClick={ () => history.push('/compras/proveedores/' + value[0])}/>
                            { value[1] === 'active'
                                ? <MenuItem onClick={ () => this.props.changeSupplierStatus(value[0], 'inactive') } icon="eye-off" text="Desactivar"/>
                                : value[1] === 'inactive'
                                    ? <MenuItem onClick={ () => this.props.changeSupplierStatus(value[0], 'active') } icon="eye-open" text="Activar"/>
                                    : null
                            }
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        // Filters
        let statsZone = (
            <div className="row stats-zone" style={{ marginBottom: 20 }} >
                <div className="col-auto">
                    <span className="label "><strong>{ suppliers.size }</strong></span>
                    <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: '' }) } >
                        <strong>Proveedores</strong>
                    </span>
                </div>
                <div className="col-auto">
                    <span className="label label-primary">{ suppliers.count(supplier => supplier.get('status') === 'active') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: 'active' }) } >Activos</span>
                </div>
                <div className="col-auto">
                    <span className="label label-danger">{ suppliers.count(supplier => supplier.get('status') === 'inactive') }</span>
                    <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: 'inactive' }) } >Inactivos</span>
                </div>
            </div>
        );
        switch (suppliersFilter) {
            case 'active':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ suppliers.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: '' }) } >
                                Proveedores
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">
                                <strong>{ suppliers.count(supplier => supplier.get('status') === 'active') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: 'active' }) } >
                                <strong>Activos</strong>
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">{ suppliers.count(supplier => supplier.get('status') === 'inactive') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: 'inactive' }) } >Inactivos</span>
                        </div>
                    </div>
                );
                tableData = suppliers.filter( supplier => supplier.get('status') === 'active' );
                break;
            case 'inactive':
                statsZone = (
                    <div className="row stats-zone" style={{ marginBottom: 20 }} >
                        <div className="col-auto">
                            <span className="label ">{ suppliers.size }</span>
                            <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: '' }) } >
                                Proveedores
                            </span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-primary">{ suppliers.count(supplier => supplier.get('status') === 'active') }</span>
                            <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: 'active' }) } >Activos</span>
                        </div>
                        <div className="col-auto">
                            <span className="label label-danger">
                                <strong>{ suppliers.count(supplier => supplier.get('status') === 'inactive') }</strong>
                            </span>
                            <span className="handPointer" onClick={ () => this.setState({ suppliersFilter: 'inactive' }) } >
                                <strong>Inactivos</strong>
                            </span>
                        </div>
                    </div>
                );
                tableData = suppliers.filter( supplier => supplier.get('status') === 'inactive' );
                break;
            default :
                break;
        }

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/compras/resumen">Compras</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                <strong>Proveedor</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <button className="btn btn-primary" onClick={ () => history.push('/compras/proveedores/nuevo') } > <Icon icon="insert"/>Proveedor</button>
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    { statsZone }
                    <div className="row">
                        <div className="col">

                            <div className="ibox">
                                <div className="ibox-content">
                                    <VirtualizedTable
                                        tableSettings={tableSettings}
                                        tableColumns={tableColumns}
                                        tableData={tableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const suppliersReducer = state.suppliers;

    // Suppliers
    let suppliers = suppliersReducer.get('payload') || List([]);

    if (!(suppliers instanceof List)) {
        suppliers = List([]);
    }

    return {
        suppliers
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSuppliers: (query) => dispatch(getSuppliers(query)),
        changeSupplierStatus: (supplierId, status) => dispatch(changeSupplierStatus(supplierId, status))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuppliersPage);


// WEBPACK FOOTER //
// ./src/containers/purchases/suppliers/SuppliersPage.js